export const useCategoryName = (categories: any[], id: number) => {
    return categories.find((c: any) => c.id == id)?.name ?? ''
}
